import { render } from "./redirect.vue?vue&type=template&id=0a43beb4&scoped=true"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"

import "./redirect.vue?vue&type=style&index=0&id=0a43beb4&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a43beb4"]])

export default __exports__